import dayjs from 'dayjs';
import arraySupport from 'dayjs/plugin/arraySupport';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import isoWeek from 'dayjs/plugin/isoWeek';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import localeData from 'dayjs/plugin/localeData';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import minMax from 'dayjs/plugin/minMax';
import objectSupport from 'dayjs/plugin/objectSupport';
import pluralGetSet from 'dayjs/plugin/pluralGetSet';
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';
import utc from 'dayjs/plugin/utc';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';

dayjs.extend(pluralGetSet);
dayjs.extend(weekOfYear);
dayjs.extend(customParseFormat);
dayjs.extend(objectSupport);
dayjs.extend(arraySupport);
dayjs.extend(utc);
dayjs.extend(minMax);
dayjs.extend(LocalizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isBetween);
dayjs.extend(localeData);
dayjs.extend(duration);
dayjs.extend(updateLocale);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
dayjs.extend(weekYear);
dayjs.extend(weekOfYear);

const durationToObject = (d) => {
    if (typeof d === 'string') {
        const durationSplit = d.split('.');
        const days = durationSplit.length === 2 ? durationSplit[0] : 0;
        const time = dayjs(durationSplit[1] || durationSplit[0], 'HH:mm:ss');
        return {
            days,
            hours: time.hours(),
            minutes: time.minutes(),
            seconds: time.seconds(),
        };
    }
    return d;
};

const copsMoment = (...args) => {
    if (args.length === 0) {
        // Return a default value or handle empty call behavior. Format: '2021-02-15T15:15:00.000Z'
        // Hardcode here or use localstorage to overwrite cops time
        if (localStorage.getItem('currentCOPSTime')) {
            return dayjs(localStorage.getItem('currentCOPSTime'));
        }
        return dayjs(...args);
    }
    return dayjs(...args);
};

Object.assign(copsMoment, dayjs);

copsMoment.duration = (durationString, format) =>
    dayjs.duration(durationToObject(durationString), format);


export default copsMoment;
